import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { useParams, useNavigate } from 'react-router-dom';
import { useWindowSize } from '../../utils';
import { WINDOW_WIDTH_CHANGE_TO_MOBILE_ITEM_DETAIL } from '../../constants/constants';
import { PRODUCT_IMAGES_URL_PREFIX } from '../../constants/constants';
import BackgroundImage from '../../images/yale_golf_course.jpg';
import { useCart } from '../../context/CartContext';


function ShopDetailSection() {
  
    const { id } = useParams();
    const navigate = useNavigate();
    const { addToCart } = useCart();

    const [windowWidth, windowHeight] = useWindowSize();

    const [itemData, setItemData] = useState({})
    const [pageLoading, setPageLoading] = useState(true)
    const [selectedImage, setSelectedImage] = useState("")
    const [addedToCart, setAddedToCart] = useState(false)

    const [itemQuantity, setItemQuantity] = useState("1")
    const [total, setTotal] = useState("")
    const [maxQuantity, setMaxQuantity] = useState(10)

    const handleAddToCart = () => {
        const qty = parseInt(itemQuantity, 10) || 1;
        addToCart({
            itemId: itemData['itemId'],
            name:   itemData['name'],
            price:  itemData['price'],
            images: itemData['images'],
            quantity: qty,
        });
        setAddedToCart(true);
        setTimeout(() => setAddedToCart(false), 2500);
    };

    const fetchData = async () => {
        const q = query(collection(db, "products"), where("itemId", "==", id));
        const querySnapshot = await getDocs(q);
        let itemDataLocal = {}
        querySnapshot.forEach((doc) => {
            const docData = doc.data()
            const imgUrls = []
            for (var i = 0; i < docData.images.length; i++) {
                const imgUrl = PRODUCT_IMAGES_URL_PREFIX + docData.images[i]
                imgUrls.push(imgUrl)
            }
            itemDataLocal = {
                name: docData.name,
                itemId: docData.itemId,
                images: imgUrls,
                color: docData.color,
                price: docData.price,
                quantityRemaining: docData.quantityRemaining,
                description: docData.description
            }
            setSelectedImage(imgUrls[0])
            const localTotal = "$" + ((docData.price / 100).toFixed(2)).toString()
            setTotal(localTotal)
            setItemQuantity("")
            // Cap quantity selector to available stock
            if (docData.quantityRemaining != null) {
                setMaxQuantity(docData.quantityRemaining > 0 ? docData.quantityRemaining : 0)
            }
        });
        setItemData(itemDataLocal)
        setPageLoading(false)
    }

    useEffect(() => {
        fetchData()
    }, []);

    const selectImage = (event) => {
        const imageUrl = event.target.alt
        setSelectedImage(imageUrl)
    }

    const displayImages = () => {
        const imagesLocal = itemData['images']
        const imageIconList = []
        for (var i = 0; i < imagesLocal.length; i++) {
            const imageUrl = imagesLocal[i]
            if (imagesLocal[i] === selectedImage) {
                imageIconList.push(
                    <img src={`/${imageUrl}`} key={imageUrl} alt={imageUrl} style={{ width: "50px", marginRight: "12px", borderRadius: "3px", boxShadow: "0 2px 8px rgba(0,0,0,0.4)", cursor: "pointer", borderStyle: "solid", borderWidth: "2px", borderColor: "#B8892A" }} />
                )
            }
            else  {
                imageIconList.push(
                    <img src={`/${imageUrl}`} onClick={(event) => selectImage(event)} key={imageUrl} alt={imageUrl} style={{ width: "50px", marginRight: "12px", borderRadius: "3px", boxShadow: "0 2px 8px rgba(0,0,0,0.4)", cursor: "pointer", borderStyle: "solid", borderWidth: "2px", borderColor: "transparent", opacity: "0.75" }} />
                )
            }
        }
        return (
            <>
                <img src={`/${selectedImage}`} alt="img" style={{ width: "100%", marginBottom: "14px", borderRadius: "4px", boxShadow: "0 4px 24px rgba(13,24,16,0.5)" }} />
                <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>{imageIconList}</div>
            </>
        )
    }

    const incrementQuantity = () => {
        var localQuantity = 1
        if (itemQuantity != "") {
            localQuantity = parseInt(itemQuantity)
        }
        if (localQuantity < maxQuantity) {
            localQuantity += 1
            setItemQuantity(localQuantity.toString())
            // calculate total
            const localTotal = "$" + (((itemData['price'] / 100) * localQuantity).toFixed(2)).toString()
            setTotal(localTotal)
        }
    }

    const decrementQuantity = () => {
        var localQuantity = 1
        if (itemQuantity != "") {
            localQuantity = parseInt(itemQuantity)
        }
        if (localQuantity > 1) {
            localQuantity -= 1
            setItemQuantity(localQuantity.toString())
            // calculate total
            const localTotal = "$" + (((itemData['price'] / 100) * localQuantity).toFixed(2)).toString()
            setTotal(localTotal)
        }
    }

    const setItemQuantityText = (event) => {
        const rawStringValue = event.target.value
        if (rawStringValue == "") {
            setItemQuantity("")
            localQuantity = 1
        }
        else if (isNaN(rawStringValue)) {
            setItemQuantity("")
        }
        else if (parseInt(rawStringValue) == 0) {
            setItemQuantity("")
        }
        else {
            var localQuantity = parseInt(rawStringValue)
            setItemQuantity(localQuantity)
        }
        
        if (localQuantity >= 1 && localQuantity <= maxQuantity) {
            // calculate total
            const localTotal = "$" + (((itemData['price'] / 100) * localQuantity).toFixed(2)).toString()
            setTotal(localTotal)
        }
    }

    const displayItemData = () => {
        const itemId = itemData['itemId']
        const itemName = itemData['name']
        const itemDescription = itemData['description']
        const itemPrice = "$" + (itemData['price'] / 100).toString()
        const qtyRemaining = itemData['quantityRemaining']
        const outOfStock = qtyRemaining === 0
        if (windowWidth > WINDOW_WIDTH_CHANGE_TO_MOBILE_ITEM_DETAIL) {
            return (
                <div style={{ alignContent: "center" }}>
                    <h3 style={{ color: "#C4A875", fontFamily: "Raleway, sans-serif", fontWeight: "500", fontSize: "13px", letterSpacing: "1px", textTransform: "uppercase", marginBottom: "28px" }}>
                        <a href='/' style={{ color: "#C4A875", textDecoration: "none" }}>Home</a>
                        <span style={{ color: "#B8892A", margin: "0 6px" }}>&#47;</span>
                        <a href='/shop' style={{ color: "#C4A875", textDecoration: "none" }}>Shop</a>
                        <span style={{ color: "#B8892A", margin: "0 6px" }}>&#47;</span>
                        <a href={`/shop/detail/${itemId}`} style={{ color: "#F5EFE3", textDecoration: "none" }}>{itemName}</a>
                    </h3>
                    <div style={{ display: "flex" }}>
                        <div style={{ width: "50%", padding: "15px" }}>
                            {displayImages()}
                        </div>
                        <div style={{ width: "50%", padding: "15px" }}>
                            <p style={{ fontSize: "40px", paddingTop: "0px", fontFamily: "Playfair Display, Georgia, serif", fontWeight: "700", color: "#F5EFE3", lineHeight: "1.15" }}>{itemName}</p>
                            <p style={{ fontSize: "26px", paddingTop: "10px", color: "#B8892A", fontFamily: "Raleway, sans-serif", fontWeight: "500" }}>{itemPrice}</p>
                            <p style={{ fontSize: "16px", paddingTop: "20px", color: "#C4A875", fontFamily: "Raleway, sans-serif", lineHeight: "1.7" }}>{itemDescription}</p>
                            <div style={{ fontSize: "14px", paddingTop: "20px", color: "#F5EFE3", fontFamily: "Raleway, sans-serif" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                                    <span style={{ color: "#C4A875" }}>{itemName}</span>
                                    <span style={{ fontWeight: "600", color: "#B8892A" }}>{itemPrice}</span>
                                    <button onClick={decrementQuantity} style={{ width: "35px", height: "32px", background: "transparent", border: "1px solid rgba(184,137,42,0.5)", borderRadius: "4px", color: "#B8892A", fontSize: "18px", cursor: "pointer" }}>-</button>
                                    <input 
                                        type="text" 
                                        value={itemQuantity} 
                                        onChange={(event) => setItemQuantityText(event)} 
                                        placeholder="1"
                                        style={{ width: "40px", height: "32px", paddingLeft: "8px", background: "rgba(255,255,255,0.08)", border: "1px solid rgba(184,137,42,0.4)", borderRadius: "4px", color: "#F5EFE3", fontFamily: "Raleway, sans-serif" }}
                                    />
                                    <button onClick={incrementQuantity} style={{ width: "35px", height: "32px", background: "transparent", border: "1px solid rgba(184,137,42,0.5)", borderRadius: "4px", color: "#B8892A", fontSize: "18px", cursor: "pointer" }}>+</button>
                                </div>
                                <div style={{ marginTop: "24px", marginBottom: "24px" }}>
                                    <hr style={{ borderColor: "rgba(184,137,42,0.25)", borderWidth: "1px 0 0" }} />
                                </div>
                                {outOfStock ? (
                                    <div style={{ padding: "16px 0" }}>
                                        <p style={{ fontFamily: "Raleway, sans-serif", fontSize: "13px", letterSpacing: "1.5px", textTransform: "uppercase", color: "#8A8A82" }}>Out of Stock</p>
                                        <p style={{ fontFamily: "Raleway, sans-serif", fontSize: "13px", color: "#8A8A82", marginTop: "6px" }}>This item is currently unavailable. Check back soon.</p>
                                    </div>
                                ) : (
                                <div style={{ display: 'grid', gridAutoFlow: 'column' }}>
                                    <div>
                                        <div style={{ fontSize: "13px", letterSpacing: "1.5px", textTransform: "uppercase", color: "#C4A875" }}>
                                            Total price:
                                        </div>
                                        <div style={{ fontWeight: "700", fontSize: "28px", paddingTop: "8px", color: "#B8892A", fontFamily: "Raleway, sans-serif" }}>
                                            {total}
                                        </div>
                                        {qtyRemaining != null && qtyRemaining <= 5 && qtyRemaining > 0 && (
                                            <p style={{ fontFamily: "Raleway, sans-serif", fontSize: "12px", color: "#C4A875", marginTop: "6px", letterSpacing: "0.5px" }}>Only {qtyRemaining} left</p>
                                        )}
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                                        <button
                                            onClick={handleAddToCart}
                                            style={{ padding: "12px 28px", background: addedToCart ? "transparent" : "#B8892A", color: addedToCart ? "#B8892A" : "#F5EFE3", border: "2px solid #B8892A", borderRadius: "4px", fontFamily: "Raleway, sans-serif", fontWeight: 600, fontSize: "11px", letterSpacing: "2px", textTransform: "uppercase", cursor: "pointer", transition: "all 0.25s" }}
                                        >
                                            {addedToCart ? "✓ Added!" : "Add to Cart"}
                                        </button>
                                        {addedToCart && (
                                            <button onClick={() => navigate('/cart')} style={{ marginLeft: "12px", color: "#B8892A", fontFamily: "Raleway, sans-serif", fontSize: "13px", fontWeight: 600, background: "none", border: "none", cursor: "pointer", padding: 0 }}>View Cart →</button>
                                        )}
                                    </div>
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        else {
            return (
                <div style={{ alignContent: "center" }}>
                    <h3 style={{ color: "#C4A875", fontFamily: "Raleway, sans-serif", fontWeight: "500", fontSize: "13px", letterSpacing: "1px", textTransform: "uppercase", marginBottom: "28px" }}>
                        <a href='/' style={{ color: "#C4A875", textDecoration: "none" }}>Home</a>
                        <span style={{ color: "#B8892A", margin: "0 6px" }}>&#47;</span>
                        <a href='/shop' style={{ color: "#C4A875", textDecoration: "none" }}>Shop</a>
                        <span style={{ color: "#B8892A", margin: "0 6px" }}>&#47;</span>
                        <a href={`/shop/detail/${itemId}`} style={{ color: "#F5EFE3", textDecoration: "none" }}>{itemName}</a>
                    </h3>
                    <div style={{ }}>
                        <div style={{ width: "100%", padding: "15px", display: "flex", justifyContent: "center" }}>
                            <div style={{ width: "100%" }}>
                                {displayImages()}
                            </div>
                        </div>
                        <div style={{ width: "100%", padding: "15px" }}>
                            <p style={{ fontSize: "36px", paddingTop: "0px", fontFamily: "Playfair Display, Georgia, serif", fontWeight: "700", color: "#F5EFE3", lineHeight: "1.2" }}>{itemName}</p>
                            <p style={{ fontSize: "22px", paddingTop: "10px", color: "#B8892A", fontFamily: "Raleway, sans-serif", fontWeight: "500" }}>{itemPrice}</p>
                            <p style={{ fontSize: "15px", paddingTop: "20px", color: "#C4A875", fontFamily: "Raleway, sans-serif", lineHeight: "1.7" }}>{itemDescription}</p>
                            <div style={{ fontSize: "14px", paddingTop: "20px", color: "#F5EFE3", fontFamily: "Raleway, sans-serif" }}>
                                <div style={{ display: "flex", alignItems: "center", gap: "10px", flexWrap: "wrap" }}>
                                    <span style={{ color: "#C4A875" }}>{itemName}</span>
                                    <span style={{ fontWeight: "600", color: "#B8892A" }}>{itemPrice}</span>
                                    <button onClick={decrementQuantity} style={{ width: "35px", height: "32px", background: "transparent", border: "1px solid rgba(184,137,42,0.5)", borderRadius: "4px", color: "#B8892A", fontSize: "18px", cursor: "pointer" }}>-</button>
                                    <input 
                                        type="text" 
                                        value={itemQuantity} 
                                        onChange={(event) => setItemQuantityText(event)} 
                                        placeholder="1"
                                        style={{ width: "40px", height: "32px", paddingLeft: "8px", background: "rgba(255,255,255,0.08)", border: "1px solid rgba(184,137,42,0.4)", borderRadius: "4px", color: "#F5EFE3", fontFamily: "Raleway, sans-serif" }}
                                    />
                                    <button onClick={incrementQuantity} style={{ width: "35px", height: "32px", background: "transparent", border: "1px solid rgba(184,137,42,0.5)", borderRadius: "4px", color: "#B8892A", fontSize: "18px", cursor: "pointer" }}>+</button>
                                </div>
                                <div style={{ marginTop: "24px", marginBottom: "24px" }}>
                                    <hr style={{ borderColor: "rgba(184,137,42,0.25)", borderWidth: "1px 0 0" }} />
                                </div>
                                {outOfStock ? (
                                    <div style={{ padding: "12px 0" }}>
                                        <p style={{ fontFamily: "Raleway, sans-serif", fontSize: "13px", letterSpacing: "1.5px", textTransform: "uppercase", color: "#8A8A82" }}>Out of Stock</p>
                                        <p style={{ fontFamily: "Raleway, sans-serif", fontSize: "13px", color: "#8A8A82", marginTop: "6px" }}>This item is currently unavailable. Check back soon.</p>
                                    </div>
                                ) : (
                                <div style={{ display: 'grid', gridAutoFlow: 'column' }}>
                                    <div>
                                        <div style={{ fontSize: "13px", letterSpacing: "1.5px", textTransform: "uppercase", color: "#C4A875" }}>
                                            Total price:
                                        </div>
                                        <div style={{ fontWeight: "700", fontSize: "26px", paddingTop: "8px", color: "#B8892A", fontFamily: "Raleway, sans-serif" }}>
                                            {total}
                                        </div>
                                        {qtyRemaining != null && qtyRemaining <= 5 && qtyRemaining > 0 && (
                                            <p style={{ fontFamily: "Raleway, sans-serif", fontSize: "12px", color: "#C4A875", marginTop: "6px", letterSpacing: "0.5px" }}>Only {qtyRemaining} left</p>
                                        )}
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                                        <button
                                            onClick={handleAddToCart}
                                            style={{ padding: "12px 24px", background: addedToCart ? "transparent" : "#B8892A", color: addedToCart ? "#B8892A" : "#F5EFE3", border: "2px solid #B8892A", borderRadius: "4px", fontFamily: "Raleway, sans-serif", fontWeight: 600, fontSize: "11px", letterSpacing: "2px", textTransform: "uppercase", cursor: "pointer", transition: "all 0.25s" }}
                                        >
                                            {addedToCart ? "✓ Added!" : "Add to Cart"}
                                        </button>
                                        {addedToCart && (
                                            <button onClick={() => navigate('/cart')} style={{ marginLeft: "12px", color: "#B8892A", fontFamily: "Raleway, sans-serif", fontSize: "13px", fontWeight: 600, background: "none", border: "none", cursor: "pointer", padding: 0 }}>View Cart →</button>
                                        )}
                                    </div>
                                </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )
        }
        
    }

    if (pageLoading) {
        return (
            <>
            </>
        )
    }

    return (
        <>
            <div style={{ backgroundImage: `linear-gradient( rgba(13, 24, 16, 0.55), rgba(13, 24, 16, 0.85) ), url(${BackgroundImage})`, backgroundSize: "cover", backgroundPosition: "center", backgroundAttachment: "fixed" }}>
                <div style={{ paddingTop: "125px", paddingBottom: "60px", minHeight: "calc(100vh - 200px)", display: "flex", justifyContent: "center" }}>
                    <div style={{ width: "90%", maxWidth: "900px" }}>
                        {displayItemData()}
                    </div>
                </div>
            </div>
        </>
    );
}

export default ShopDetailSection;